<template>
  <VWidget
    :title="$t('Taxonomy details')"
    class="mb-4"
  >
    <div slot="widget-content">
      <translatable
        :language="language"
        v-model="taxonomy"
        field-name="name"
      >
        <template
          #default="{ fieldValue, fieldMutator }"
        >
          <v-text-field
            v-model="fieldValue"
            :label="$t('Title')"
            outline
            @change="fieldMutator(fieldValue)"
          />
        </template>
      </translatable>
    </div>
  </VWidget>
</template>

<script>
import Translatable from '@/components/widgets/Translatable'

export default {
  name: 'TaxonomySingleName',

  components: {
    Translatable
  },
  props: {
    taxonomy: {
      type: Object,
      required: true
    },
    language: {
      type: Object,
      required: false,
      default: () => null
    }
  }
}
</script>
